import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzHeading } from '../../../components';



const Holdings = ({ sector, holdings }) => {

    return (<>
        <Container fluid className='p-0 ps-4'>
            <Row className='g-0'>
                <Col>
                    <BzHeading className='font-medium font-size5 color-text'>Holdings</BzHeading>
                </Col>
            </Row>
            <Row className='g-0'>
                <Col>
                    <div className='my-3'>
                        <div className='progress' style={{ height: "50px" }}>
                            <div className='progress-bar text-left' role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: holdings.largeCap }}>
                                <div>Large Cap</div>
                                <div>{holdings.largeCap}</div>
                            </div>
                            <div className='progress-bar bg-success' role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: holdings.midCap }}>
                                <div>Mid Cap</div>
                                <div>{holdings.midCap}</div>
                            </div>
                            <div className='progress-bar bg-warning' role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: holdings.smallCap }}>
                                <div>Small Cap</div>
                                <div>{holdings.smallCap}</div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className='g-0 mt-2'>
                <Col>
                    <BzHeading className='font-medium font-size3 color-text pb-3'>Sector</BzHeading>
                </Col>
            </Row>
            <Row className='p-0'>
                <Col>
                    {sector?.map((item, index) => {
                        return (
                            <div key={index}>
                                <Row className='g-0 pb-3'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='holdingsectors-dot darkblue-holdingsector-allocation me-2'>&nbsp;</div>
                                        <div className='font-regular font-size2 color-text'>Banks</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-start'>
                                        <div className='font-regular font-size3 color-text'>{item.banks}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 pb-3'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='holdingsectors-dot lightblue-holdingsector-allocation me-2'>&nbsp;</div>
                                        <div className='font-regular font-size2 color-text'>Finance</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-start'>
                                        <div className='font-regular font-size3 color-text'>{item.finance}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 pb-3'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='holdingsectors-dot green-holdingsector-allocation me-2'>&nbsp;</div>
                                        <div className='font-regular font-size2 color-text'>IT-Software</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-start'>
                                        <div className='font-regular font-size3 color-text'>{item.itSoftware}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 pb-3'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='holdingsectors-dot pink-holdingsector-allocation me-2'>&nbsp;</div>
                                        <div className='font-regular font-size2 color-text'>Automobile</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-start'>
                                        <div className='font-regular font-size3 color-text'>{item.automobile}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 pb-3'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='holdingsectors-dot yellow-holdingsector-allocation me-2'>&nbsp;</div>
                                        <div className='font-regular font-size2 color-text'>Insurance</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-start'>
                                        <div className='font-regular font-size3 color-text'>{item.insurance}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mt-1'>
                                    <Col className='d-flex justify-content-end align-items-center'>
                                        <BzHeading className='font-medium font-size2 color-textual-link-withicon cursor-pointer'>Show More</BzHeading>
                                        <div className='icon-20 icon-sort-down background-textual-link-withicon ms-2'></div>
                                        {/* <div className='icon-20 icon-sort-up background-textual-link-withicon ms-2'></div> */}
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                </Col>
            </Row>
        </Container>
    </>);
};
export default memo(Holdings);